import Vue from "vue";
import Vuetify from "vuetify/lib";

// Manually import the components which are used in functional components, as vuetify-loader won't pick them up
// More info: https://vuetifyjs.com/en/features/treeshaking/#functional-components
Vue.use(Vuetify, {});

export default new Vuetify({
    icons: {
        values: {
            info: "mdi-information-outline",
        },
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                //.env files contain what this primary colour will be
                primary: `#${process.env.VUE_APP_PRIMARY_COLOR}`,
                secondary: "#26CFA7",
                error: "#F03A47",
                info: "#4D96F2",
                success: "#26CFA7",
                warning: "#F7D734",
                anchor: "inherit",
            },
        },
    },
});

declare module "vue/types/vue" {
    interface Vue {
        $vuetify: Vuetify["framework"];
    }
}
